// queryConfig.ts
export const queryConfig = {
  staleTime: 15 * 1000, // 15 second
  cacheTime: 15 * 1000, //15 second
  retry: 1, // Retries the query up to 1 times in case of failure
};
